import MasterCopy from "../../common/models/MasterCopy";
import SongCollection from "../../common/models/SongCollections";
import SongToken from "../../common/models/SongToken";

export enum SongType {
  MASTER_COPY = 0,
  COLLECTIBLE = 1,
  TOKEN = 2,
}
export default class Song {
  artist_wallet_address: string = "";
  artist_stage_name: string = "";
  owner_address: string = "";
  song_name: string = "";
  id: number = 0;
  launch_date: number = 0;
  song_cover_s3_link: string = "";
  for_sale: boolean = false;
  description: string = "";
  nft_address: string = "";
  license_address: string = "";
  price: number = 0;
  preview_song_url: string = "";
  active_listing_id: string = "";
  quantity: number = 0;
  minted: number = 0;
  type: number = SongType.MASTER_COPY;
  // Default is 1 because Master Copies always have token Id as 1
  tokenId: number = 1;
  collectionId: number = 0;
  for_secondary_sale: boolean = false;
  royalty_percentage: number = 0;
  spotify_url: string = "";
  youtube_url: string = "";
  metadata_base_url: string = "";

  static fromMasterCopy(masterCopy: MasterCopy): Song {
    const song = new Song();

    song.artist_wallet_address = masterCopy.artist_wallet_address;
    song.artist_stage_name = masterCopy.artist_stage_name;
    song.owner_address = masterCopy.owner_address;
    song.song_name = masterCopy.song_name;
    song.id = masterCopy.id;
    song.launch_date = masterCopy.launch_date;
    song.song_cover_s3_link = masterCopy.song_cover_s3_link;
    song.description = masterCopy.description;
    song.nft_address = masterCopy.nft_address;
    song.price = masterCopy.price;
    song.preview_song_url = masterCopy.preview_song_url;
    song.license_address = masterCopy.license_address;
    song.active_listing_id = masterCopy.active_listing_id;
    song.for_sale = masterCopy.for_sale;
    song.spotify_url = masterCopy.spotify_url;
    song.youtube_url = masterCopy.youtube_url;
    song.metadata_base_url = masterCopy.metadata_base_url;
    song.type = SongType.MASTER_COPY;
    return song;
  }

  static fromSongCollection(songCollection: SongCollection): Song {
    const song = new Song();
    song.artist_wallet_address = songCollection.artist_wallet_address;
    song.artist_stage_name = songCollection.artist_stage_name;
    song.owner_address = songCollection.artist_wallet_address;
    song.song_name = songCollection.song_name;
    song.id = songCollection.id;
    song.collectionId = songCollection.id;
    song.launch_date = songCollection.launch_date;
    song.song_cover_s3_link = songCollection.song_cover_s3_link;
    song.description = songCollection.description;
    song.nft_address = songCollection.nft_address;
    song.price = songCollection.mint_price;
    song.preview_song_url = songCollection.preview_song_url;
    song.quantity = songCollection.quantity;
    song.minted = songCollection.minted;
    song.for_secondary_sale = songCollection.for_secondary_sale;
    song.royalty_percentage = songCollection.royalty_percentage;
    song.spotify_url = songCollection.spotify_url;
    song.youtube_url = songCollection.youtube_url;
    song.metadata_base_url = songCollection.metadata_base_url;
    song.type = SongType.COLLECTIBLE;

    return song;
  }

  static fromSongToken(
    songToken: SongToken,
    songCollection: SongCollection
  ): Song {
    const song = new Song();
    song.collectionId = songToken.collection_id;
    song.nft_address = songToken.contract_address;
    song.for_sale = songToken.for_sale;
    song.id = songToken.id;
    song.price = songToken.price;
    song.song_name = songToken.song_name;
    song.tokenId = songToken.token_id;
    song.song_cover_s3_link = songCollection.song_cover_s3_link;
    song.description = songCollection.description;
    song.preview_song_url = songCollection.preview_song_url;
    song.quantity = songCollection.quantity;
    song.minted = songCollection.minted;
    song.artist_stage_name = songCollection.artist_stage_name;
    song.artist_wallet_address = songCollection.artist_wallet_address;
    song.owner_address = songToken.owner;
    song.for_secondary_sale = songCollection.for_secondary_sale;
    song.royalty_percentage = songCollection.royalty_percentage;
    song.spotify_url = songCollection.spotify_url;
    song.youtube_url = songCollection.youtube_url;
    song.metadata_base_url = songCollection.metadata_base_url;
    song.type = SongType.TOKEN;
    return song;
  }

  static toSongCollection = (song: Song) : SongCollection => {
    const songCollection =  new SongCollection()
    songCollection.artist_wallet_address = song.artist_wallet_address;
    songCollection.artist_stage_name = song.artist_stage_name;
    songCollection.song_name = song.song_name;
    songCollection.id = song.id;
    songCollection.launch_date = song.launch_date;
    songCollection.song_cover_s3_link = song.song_cover_s3_link;
    songCollection.description = song.description;
    songCollection.nft_address = song.nft_address;
    songCollection.mint_price = song.price;
    songCollection.preview_song_url = song.preview_song_url;
    songCollection.quantity = song.quantity;
    songCollection.minted = song.minted;
    songCollection.for_secondary_sale = song.for_secondary_sale;
    songCollection.royalty_percentage = song.royalty_percentage;
    songCollection.spotify_url = song.spotify_url;
    songCollection.youtube_url = song.youtube_url;
    return songCollection;

  }
}
